<form class="save-cart-modal" (submit)="onSubmit($event)">
  <span class="save-cart-modal-title">{{ 'cart.modal.save.title' | translate }}</span>
  <span class="save-cart-modal-description">{{ 'cart.modal.save.description' | translate }}</span>

  <cx-input-field id="user" type="text" label="Nome do carrinho *" [formControl]="control" [invalid]="!!control.errors" />

  @if (control.errors) {
    <cx-form-errors [control]="control" />
  }

  <div class="save-cart-modal-footer">
    <cx-button (click)="onCancel()" [type]="'button'" class="btn-outline w-100">{{ 'cart.modal.save.cancel' | translate }}</cx-button>
    <cx-button [disabled]="!!control.errors" [type]="'submit'" class="w-100">{{ 'cart.modal.save.submit' | translate }}</cx-button>
  </div>
</form>
